import { Control, Controller } from "react-hook-form";

import { FormLabel } from "@ui/FormElements";
import { CompanySelect, ICreateDealForm } from "@components/AddNewEntity/Deal";

interface ICompanyFormFieldProps {
  control: Control<ICreateDealForm>;
}

export function CompanyFormField({ control }: ICompanyFormFieldProps) {
  return (
    <Controller
      control={control}
      name="company"
      render={({ field: { value, onChange } }) => (
        <div className="flex flex-col justify-between gap-1">
          <FormLabel htmlFor="type">Company</FormLabel>
          <div className="w-full">
            <CompanySelect
              value={value}
              onChange={(option) => onChange(option)}
              className="w-full"
            />
          </div>
        </div>
      )}
    />
  );
}
